<template>
  <a
    class="btn-back"
    title="Назад"
    @click="hasHistory() ? $router.go(-1) : $router.push('/')"
    >&#10140;
  </a>
</template>
<script>
export default {
  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    
  },
};
</script>
